// Human-friendly labels for internal codes. The DB always stores the code;
// the UI always renders these labels to applicants/admins.

export const ACCREDITATION_TYPE_LABEL = {
  institutional: "Institutional Accreditation",
  programmatic: "Programmatic Accreditation",
};

export const ACCREDITATION_TYPE_DESCRIPTION = {
  institutional:
    "Accreditation applies to the institution as a whole. Graduates from approved programs within the institution may be eligible for IBTHM credentialing review.",
  programmatic:
    "Accreditation applies only to specific programs. Only graduates from the explicitly accredited program(s) are eligible for IBTHM credentialing review.",
};

export const CREDENTIAL_TYPE_LABEL = {
  // IBTHM credentialing track (practitioner-facing)
  "IBTHM-CT": "Board Certified Trichologist (BCT)",
  "BCT": "Board Certified Trichologist (BCT)",
  "IBTHM-Trichologist": "Board Certified Trichologist (BCT)",
  "IBTHM-Holistic": "Board Certified Holistic Health Practitioner (BCHHP)",
  "BCHHP": "Board Certified Holistic Health Practitioner (BCHHP)",
  "IBTHM-Drugless": "Board Certified Doctor of Trichology Science (BCDTS)",
  "BCDTS": "Board Certified Doctor of Trichology Science (BCDTS)",
  "LHT": "Licensed Holistic Trichologist (LHT)",
  // ACIS — institutional accreditation types ONLY (never practitioner credentials)
  "ACIS-IA": "Institutional Accreditation",
  "ACIS-PA": "Programmatic Accreditation",
  "institutional": "Institutional Accreditation",
  "programmatic":  "Programmatic Accreditation",
};

export function credentialLabel(code) {
  if (!code) return "—";
  return CREDENTIAL_TYPE_LABEL[code] || code;
}

export const PAYMENT_TYPE_LABEL = {
  acis_application_fee: "ACIS Accreditation Application Fee",
  acis_renewal_fee: "ACIS Accreditation Renewal Fee",
  ibthm_application_fee: "IBTHM Board Certification Application Fee",
  ibthm_license_fee: "IBTHM Licensing Application Fee",
  ibthm_renewal_fee: "IBTHM Renewal Fee",
  ibthm_reinstatement_fee: "IBTHM Reinstatement Fee",
};

export const PAYMENT_TYPE_DESCRIPTION = {
  acis_application_fee: "Required before submitting an institutional or programmatic accreditation application.",
  acis_renewal_fee: "Required before submitting an accreditation renewal request.",
  ibthm_application_fee: "Required before submitting a board certification application.",
  ibthm_license_fee: "Required before submitting a license application.",
  ibthm_renewal_fee: "Required before submitting a credential renewal.",
  ibthm_reinstatement_fee: "Required before submitting a reinstatement request.",
};
